import apiSlice from '../../services/api/slice'
import { TAGS } from '../../constants/tags'

const importSlice = apiSlice.injectEndpoints({
  name: 'imports',
  endpoints: (builder) => ({
    getSignedUrl: builder.mutation({
      query: ({ payload }) => ({ url: '/v1/admin/imports/url', method: 'POST', body: payload }),
      transformResponse: (response) => response.data,
    }),
    getImports: builder.query({
      query: () => ({ url: '/v1/admin/imports', method: 'GET' }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.IMPORTS],
    }),
    getImport: builder.query({
      query: ({ importId }) => ({ url: `/v1/admin/imports/${importId}`, method: 'GET' }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.IMPORT],
    }),
    putImportFields: builder.mutation({
      query: ({ importId, payload }) => ({
        url: `/v1/admin/imports/${importId}/fields`,
        method: 'PUT',
        body: { fields: payload },
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: [TAGS.IMPORTS, TAGS.IMPORT],
    }),
    putImportStatus: builder.mutation({
      query: ({ importId, payload }) => {
        return {
          url: `/v1/admin/imports/${importId}/status/${payload.status}`,
          method: 'PUT',
        }
      },
      transformResponse: (response) => response.data,
      invalidatesTags: [TAGS.IMPORTS, TAGS.IMPORT],
    }),
    deleteImport: builder.mutation({
      query: ({ importId }) => ({
        url: `/v1/admin/imports/${importId}`,
        method: 'DELETE',
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: [TAGS.IMPORTS, TAGS.IMPORT],
    }),
    postImport: builder.mutation({
      query: ({ importId }) => ({
        url: `/v1/admin/imports/${importId}`,
        method: 'POST',
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: [TAGS.IMPORTS, TAGS.IMPORT],
    }),
    getImportRecords: builder.query({
      query: ({ importId }) => ({ url: `/v1/admin/imports/${importId}/records`, method: 'GET' }),
      transformResponse: (response) => {
        return response?.data?.map((item) => ({
          id: item.pk,
          ...item.record,
        }))
      },
      providesTags: [TAGS.IMPORT_RECORDS],
    }),
  }),
})

export const {
  useGetSignedUrlMutation,
  useGetImportsQuery,
  useGetImportQuery,
  useGetImportRecordsQuery,
  usePutImportFieldsMutation,
  usePutImportStatusMutation,
  useDeleteImportMutation,
  usePostImportMutation,
} = importSlice
